module.exports = __webpack_public_path__ + "static/media/SF_bm_sentrert_logo_troendelag_pos.be9f5de8.pdf";